import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PROJECT } from '../constants';
import { Get, Post, Put, DeleteSingle } from '../../utils/httpProvider';
import { fetchWithAuth } from '../../utils/httpClient';
import { PROJECT_API, PERSONALTASK_API } from '../../utils/apiUrl.js';

export const projectPagingAction = createAsyncThunk(
    PROJECT.GET_PAGING,
    async (model) => {
        return Get(PROJECT_API.GET_PAGING, null, model)
            .then((response) => response)
            .catch((error) => error);
    }
);

export const getProjectByIdAction = createAsyncThunk(
    PROJECT.GET_ITEM,
    async (id) => {
        return Get(PROJECT_API.GET_ITEM, id)
            .then((response) => response)
            .catch((error) => error);
    }
);

export const addProjectAction = createAsyncThunk(
    PROJECT.ADD,
    async (model) => {
        return Post(PROJECT_API.ADD, null, model)
            .then((response) => response)
            .catch((error) => error);
    }
);

export const updateProjectAction = createAsyncThunk(
    PROJECT.EDIT,
    async (model) => {
        return Put(PROJECT_API.UPDATE, model.id, model.data)
            .then((response) => response)
            .catch((error) => error);
    }
);

export const deleteProjectAction = createAsyncThunk(
    PROJECT.DELETE,
    async (id) => {
        return DeleteSingle(PROJECT_API.DELETE, id)
            .then((response) => response)
            .catch((error) => error);
    }
);

export const changeProjectStatusAction = createAsyncThunk(
    PROJECT.CHANGE_STATUS,
    async (model) => {
        const { id, status } = model;
        return Put(PROJECT_API.CHANGE_STATUS, id, status)
            .then((response) => response)
            .catch((error) => error);
    }
);

const initialState = {
    list: [],
    total: 0,
    item: null,
};

export const projectSlice = createSlice({
    name: PROJECT.NAME_SLICE,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(projectPagingAction.fulfilled, (state, action) => {
                const payload = action.payload;
                if (payload) {
                    let rawData = payload.data !== undefined ? payload.data : payload.Data;
                    if (rawData === undefined) rawData = payload;
                    
                    if (rawData && rawData.$values) {
                        state.list = rawData.$values;
                    } else if (Array.isArray(rawData)) {
                        state.list = rawData;
                    } else {
                        state.list = [];
                    }

                    state.total = payload.totalRecords !== undefined ? payload.totalRecords : 
                                 (payload.TotalRecords !== undefined ? payload.TotalRecords : 
                                 (Array.isArray(state.list) ? state.list.length : 0));
                } else {
                    state.list = [];
                    state.total = 0;
                }
            })
            .addCase(getProjectByIdAction.fulfilled, (state, action) => {
                state.item = action.payload?.data || action.payload || null;
            });
    }
});
